import { AxiosResponse } from 'axios';
import { auth } from '@/shared/infrastructure/clients';

type RecoveryRequest = {
  email: string;
};

const passwordRecovery = async (recovery: RecoveryRequest): Promise<AxiosResponse> =>
  auth().recoveryPasswordReset(recovery);

export { passwordRecovery };
export type { RecoveryRequest };
